module.exports = __webpack_public_path__ + "img/banner.b8c9a66b.png";